import { DateTime } from 'luxon';

const anomalies = [
    'Weather Event',
    'Weed',
    'Insect',
    'Disease',
    'Vertebrate',
    'Nutrient Deficiency',
    'Drainage Installation or Repair',
];

export const page = {
    name: 'anomalies',
    visibleIf: '{purpose} == "Anomalies"',
    title: 'Anomalies and Disorders',
    elements: [
        {
            type: 'paneldynamic',
            name: 'anomalies',
            title: 'Anomalies',
            panelCount: 1,
            panelAddText: 'Add Anomaly',
            panelRemoveText: 'Remove Anomaly',
            templateElements: [
                {
                    name: 'type',
                    title: 'Type',
                    type: 'radiogroup',
                    isRequired: true,
                    hasOther: true,
                    choices: anomalies,
                },
                {
                    name: 'description',
                    title: 'Description',
                    type: 'text',
                    isRequired: true,
                    placeHolder: 'Hail'
                },
                {
                    name: 'when',
                    title: 'When',
                    type: 'text',
                    inputType: 'datetime-local',
                    isRequired: true,
                    defaultValue: DateTime.local().toFormat("yyyy-MM-dd'T'HH:mm:ss"),
                },
                {
                    name: 'extent',
                    title: 'Extent',
                    type: 'radiogroup',
                    isRequired: true,
                    choices: ['Minor','Moderate','Severe'],
                    hasOther: true,
                },
            ],
        },
        {
            name: 'anomalies-panel-0',
            title: 'Photo 1',
            type: 'panel',
            state: 'collapsed',
            elements: [
                {
                    name: 'anomalies-photo-0',
                    title: 'Photo',
                    type: 'file',
                    storeDataAsText: false,
                    acceptedTypes: 'image/*',
                    allowMultiple: false,
                },
                {
                    name: 'anomalies-photo-0-label',
                    title: 'Label',
                    type: 'text',
                },
            ],
        },
        {
            name: 'anomalies-panel-1',
            title: 'Photo 2',
            type: 'panel',
            state: 'collapsed',
            elements: [
                {
                    name: 'anomalies-photo-1',
                    title: 'Photo',
                    type: 'file',
                    storeDataAsText: false,
                    acceptedTypes: 'image/*',
                    allowMultiple: false,
                },
                {
                    name: 'anomalies-photo-1-label',
                    title: 'Label',
                    type: 'text',
                },
            ],
        },
    ],
};


export default page;
